<template>
  <span
    class="c-chat__userIndicator"
    :class="[indicatorColorClass, small ? '-small' : '', medium ? '-medium' : '', large ? '-large' : '']" />
</template>

<script setup>
import { computed } from 'vue'

import constants from '@/constants'

const props = defineProps({
  status: {
    type: Boolean,
    required: true,
  },
  // To set small size of the indicator
  small: {
    type: Boolean,
    required: false,
    default: false,
  },
  medium: {
    type: Boolean,
    required: false,
    default: false,
  },
  large: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const indicatorColorClass = computed(() => {
  const statusClasses = {
    [constants.USER_STATUSES.OFFLINE]: '-offline',
    [constants.USER_STATUSES.ONLINE]: '-online',
  }
  return statusClasses[props.status] ?? ''
})
</script>
